// :cow: Cosmose CONFIDENTIAL :iso:
import { Action, createReducer, on } from '@ngrx/store';
import { getDomainListFailed, getDomainListRequested, getDomainListSucceeded } from './select-domain.actions';

import { DomainListResponse } from '@par/app/core/model/custom-domains.response';

export const STATE_NAME_SELECT_DOMAIN = 'select-domain';

export interface State {
  response?: DomainListResponse;
  responseError: boolean;
  responseLoading: boolean;
}

const initialState: State = {
  response: undefined,
  responseError: false,
  responseLoading: false,
};

const reducer = createReducer(
  initialState,
  on(getDomainListRequested, (state) => (
    state.response != null
      ? state
      : {...state, responseLoading: true, responseError: false}
  )),
  on(getDomainListSucceeded, (state, {response}) => ({
    ...state,
    responseLoading: false,
    response,
    responseError: false,
  })),
  on(getDomainListFailed, (state) => ({...state, responseLoading: false, responseError: true})),
);

export function selectDomainReducer(state: State | undefined, action: Action): any {
  return reducer(state, action);
}

